import styled from 'styled-components'

export const Game = styled.div`
  ${({ theme: { colors } }) => `
    position: absolute;
    bottom: 0;
    top: 0;
    left: 0;
    right: 0;
    background: ${colors('chrome')};
    z-index: 99;
  `}
`

export const QuestionContainer = styled.div`
  height: 100vh;
  flex: 1;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

export const Answer = styled.div`
  ${({ theme: { colors } }) => `
  margin: 1.25rem 0;
  padding: 0.5rem;
  font-size: 1.2rem;
  display: flex;
  justify-content: space-between;
  border-radius: 0.5rem;
  background: ${colors('text', 0.1)};
  svg,
  &.selected {
    color: ${colors('success')};
    stroke: ${colors('success')};
  }
    `}
`

export const AnswersContainer = styled.div`
  ${({ theme: { colors } }) => `
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: flex-end;
  margin: 2rem 0 5rem;
  &.disabled ${Answer} {
    pointer-events: none;
    &.correct.selected {
      background: ${colors('success', 0.2)};
    }
    &.incorrect.selected svg,
    &.incorrect.selected {
      color: ${colors('danger')};
      stroke: ${colors('danger')};
    }
    &.incorrect.selected {
      background: ${colors('danger', 0.2)};
    }
  }
    `}
`
